import React,{useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {DivRedesSociaisTopo,
    DivIconesRedesSociais,
    DivBuscaTopo,
    DivLogoTopo,
    ListaMenuPreview,
    DivOpcaoMenuPreview,
    OpcaoMenuPreview,
    InputPesquisaTopo,}
from './styleIndexPreview';
import {DivMenuOpMobile} from './styleMenuPreview';
import {IconInstagram,IconFacebook,IconTwitter,IconYoutube} from './styleIndexPreview';
import {IconFiMenu,IconVscChromeClose} from './styleMenuPreview';
import {URLIMG} from '../../helpers/constantes';

export default function MenuPreview(){
    let logo = JSON.parse(localStorage.getItem('currentUser'));
    const LogoMobile = require('../../assets/images/social51.jpeg');

    const [width] = useState(window.screen.width);
    const [displayMenu, setDisplayMenu] = useState('none');
    const [aberto, setAberto] = useState(false);

    function Menu(){
        return(<div style={{display:`${displayMenu}`,width:'100%',height:'calc(100% - 110px)',background:'#fff',zIndex:'5',margin:'110px 0 0 0',position:"fixed",overflow:'hidden'}}>
               <div style={{display:'flex',justifyContent:'flex-start',padding:'20px',flexDirection:'column',alignItems:'flex-start',height:'100%' }}>
                    <DivMenuOpMobile><InputPesquisaTopo placeholder='Pesquisar' type='text' /></DivMenuOpMobile>
                    <Link to='/previewinicio'><DivMenuOpMobile>ÍNICIO</DivMenuOpMobile></Link>
                    <DivMenuOpMobile>EMAGRECIMENTO SAUDÁVEL</DivMenuOpMobile>
                    <Link to='/preview'><DivMenuOpMobile>BLOG</DivMenuOpMobile></Link>
                    <Link to='/previewsobremim'><DivMenuOpMobile>SOBRE MIM</DivMenuOpMobile></Link>
                    <DivMenuOpMobile>
                       <IconInstagram />
                        <IconFacebook />
                        <IconTwitter />
                        <IconYoutube />
                    </DivMenuOpMobile>
               </div>
        </div>)
    }

    function MostraMenu(){
        if(displayMenu ==='none'){
            setDisplayMenu('block');
            setAberto(true)
        }else if(displayMenu === 'block'){
            setDisplayMenu('none');
            setAberto(false)
        }
    }

    useEffect(()=>{

    },[]);

    return(<div style={width > 800 ? {display:'unset'} :{width:'100%',height:'110px',display:'flex',justifyContent:'flex-end',overflow:'hidden'} }>
     {width > 800 ?
        <div id='divInicial' style={{display:'flex', flexDirection:'column'}}>
            <DivRedesSociaisTopo>
                <DivIconesRedesSociais >
                    <IconInstagram />
                    <IconFacebook />
                    <IconTwitter />
                    <IconYoutube />
                </DivIconesRedesSociais>
                <DivBuscaTopo >
                    <InputPesquisaTopo placeholder='Pesquisar' type='text' />
                </DivBuscaTopo>
            </DivRedesSociaisTopo>
            <DivLogoTopo >
                <img src={URLIMG+logo.LogoHeader} alt='' style={{maxWidth:'100%'}} />
            </DivLogoTopo>
            <div id='menuPreview' style={{backgroundColor:'#fff'}}>
                <ListaMenuPreview>
                    <DivOpcaoMenuPreview>
                        <Link to='/previewinicio'><OpcaoMenuPreview>ÍNICIO</OpcaoMenuPreview></Link>
                    </DivOpcaoMenuPreview>
                    <DivOpcaoMenuPreview>
                    <OpcaoMenuPreview>{logo  ?logo.SliderCaption2: 'Clique aqui para preenhcer o campo'}</OpcaoMenuPreview>
                    </DivOpcaoMenuPreview>
                    <DivOpcaoMenuPreview>
                    <OpcaoMenuPreview>{logo ? logo.SliderCaption3 : 'Clique aqui para preenhcer o campo'}</OpcaoMenuPreview>
                    </DivOpcaoMenuPreview>
                    <DivOpcaoMenuPreview>
                    <Link to='/preview'> <OpcaoMenuPreview>BLOG</OpcaoMenuPreview></Link>
                    </DivOpcaoMenuPreview>
                    <DivOpcaoMenuPreview>
                        <Link to='/previewsobremim'><OpcaoMenuPreview>SOBRE MIM</OpcaoMenuPreview></Link>
                    </DivOpcaoMenuPreview>
                </ListaMenuPreview>
            </div>
        </div>

    :<>
    <div style={{width:'100%',height:'110px', display:'flex',padding:'0 10px', flexDirection:'row',position:'fixed', background:'#fff'}}>
        <div style={{margin:'0 20px 0 0',width:'100%',height:'110px',display:'flex', alignItems:'center'}}>
            <img src={LogoMobile} alt='' style={{maxWidth:'100%',maxHeight:'110px'}}/>
        </div>
        <div style={{display:'flex', alignItems:'center'}}>
            {aberto ?<IconVscChromeClose onClick={()=>MostraMenu()}/> : <IconFiMenu onClick={()=>MostraMenu()}/>}
        </div>
    </div>
    {Menu()}
    </>
    }

    </div>
    )
}
